import { Component, Input } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

import { GroupInvite } from '../../models/group-invite.model';
import { ErrorReportingService } from '../../services/error-reporting.service';
import { GroupInvitesService } from '../../services/group-invites.service';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-pending-group-invites-modal',
    templateUrl: './pending-group-invites-modal.component.html',
    styleUrls: ['./pending-group-invites-modal.component.scss'],
    standalone: false
})
export class PendingGroupInvitesModalComponent {
  @Input() invites: GroupInvite[] = [];

  faSpinnerThird = faSpinnerThird;
  processingInviteId?: string;

  constructor(
    public activeModal: NgbActiveModal,
    private groupInvitesService: GroupInvitesService,
    private toastService: ToastService,
    private errorReporting: ErrorReportingService,
  ) { }

  async accept(invite: GroupInvite) {
    await this.respond(invite, true);
  }

  async decline(invite: GroupInvite) {
    await this.respond(invite, false);
  }

  reviewLater() {
    this.activeModal.dismiss('review-later');
  }

  private async respond(invite: GroupInvite, acceptsInvite: boolean) {
    this.processingInviteId = invite.id;

    try {
      const successful = await firstValueFrom(
        this.groupInvitesService.respondToGroupInvite$(invite.id, acceptsInvite)
      );

      if (!successful) {
        this.errorReporting.captureFailure('group-invite.respond', 'respondToGroupInvite returned false', {
          inviteId: invite.id,
          acceptsInvite,
        });
        this.toastService.showError('We could not update that invite right now.', {
          delay: 5000,
        });
        return;
      }

      this.invites = this.invites.filter(item => item.id !== invite.id);

      this.toastService.showInfo(
        acceptsInvite
          ? `You have joined ${invite.groupName}.`
          : `Invite declined.`,
        {
          delay: 5000,
        }
      );

      if (this.invites.length === 0) {
        this.activeModal.close('all-processed');
      }
    } catch (error) {
      this.errorReporting.captureError('group-invite.respond', error, {
        inviteId: invite.id,
        acceptsInvite,
      });
      this.toastService.showError('We could not update that invite right now.', {
        delay: 5000,
      });
    } finally {
      this.processingInviteId = undefined;
    }
  }
}
